<template>
  <div class="catering">
    <div class="pao pao1 wow"></div>
    <img src="@/assets/catering4.png" class="pao pao2 wow fadeIn">
    <img src="@/assets/catering3.png" class="pao pao3 wow slideInLeftSelf">
    <div class="pao pao5 wow slideInLeftSelf"></div>
    <myMenu :type="2" @zoomChange="initWow"></myMenu>
    <div class="catering_content"> 
      <div class="linear_word">BOONIE BEARS HOTEL</div>
      <div class="linear_word2 slideInUp_p">
        <div class="wow slideInUp">熊出没港湾酒店</div>
      </div>
      <div class="hotel_main">
        <div class="hotel_dec wow fadeInLeft">熊出没港湾酒店坐落于宁波方特旅游度假区，占地23000平方米，是华强方特集团投资建设的熊出没主题亲子休闲度假型酒店。酒店内部设计及装饰大量引入熊出没动漫元素，充分体现酒店的主题特色。酒店毗邻方特东方神画及方特东方欲晓，紧靠杭州湾跨海大桥，地理位置优越，交通便捷，周边区域绿化及基础设施建设完善，是旅游、度假、商务、会议、休闲娱乐的理想之地。</div>
        <div class="more1 wow fadeIn" @click="$toPage('https://hotel.fangte.com/ningbo/')">
          进入官网
          <span></span>
        </div>
        <div class="hotel_img wow fadeInUp">
          <img src="@/assets/hotel3.jpg">
        </div>
      </div>
      <drop class="drop1" cssVal="right: -42px;top: 800px;" :size="6"></drop>
      <div class="title title1">
        <div>
          <span class="title_span title1_span wow slideInLeftSelf">花筑民宿</span>
        </div>
      </div>
      <div class="dec dec1 wow" data-wow-offset="-100000">景区旅行，就住花筑！全国1500+门店，法式浪漫主题民宿，尽显质感与关怀，融合奇迹少女元素，享奇妙住宿体验。</div>
      <div class="pic pic1 wow" data-wow-offset="-100000"></div>
      <drop class="drop2" cssVal="left: -22px;top: 1800px;" :size="6"></drop>

      <div class="title title2">
        <div>
          <span class="title_span title2_span wow slideInLeftSelf">D娜兽</span>
        </div>
      </div>
      <div class="dec dec2 wow logos">舒适入住体验，智能科技场景，更符合年轻人生活方式的未来酒店，恐龙主题民宿，让住宿充满趣味。</div>
      <div class="pic pic2 wow" data-wow-offset="-100000">
        <img src="@/assets/hotel2.jpg">
      </div>
      <drop class="drop3" cssVal="right: -42px;top: 2900px;" :size="4"></drop>
    </div>
    <myBottom></myBottom>
  </div>
</template>

<script>
import myMenu from '@/components/myMenu.vue'
import myBottom from '@/components/myBottom.vue'
import drop from '@/components/drop.vue'

import "wowjs/css/libs/animate.css";
import "@/assets/css/wowExtra.css";
import { WOW } from 'wowjs'
// import P from '@/tools/project';

export default {
  components: { myMenu, myBottom, drop },
  data() {
    return {

    }
  },
  methods: {
    setWow() {
      $('.dec1, .pic1, .pao1').css('transform', 'translate(-20000px, 0)');
      $('.dec2, .pic2').css('transform', 'translate(-20000px, 0)');
      $('.drops').css('transform', 'translate(-20000px, 0)');
    },
    initWow(zoom) {
      var top = $('.catering .logos').offset().top;
      var offset = zoom >= 1 ? 200 * zoom : (200 * zoom - (top - top * zoom));
      var wow = new WOW(
        {
          animateClass: 'animated',
          offset,
          callback: box => {
            if (box.className.includes('hotel_img')) {
              $('.drop1').css('transform', 'translate(0, 0)');
              $('.drop1 .drop').addClass('zoomIn')
            }
            if (box.className.includes('title1_span')) {
              $('.drop2').css('transform', 'translate(0, 0)');
              $('.drop2 .drop').addClass('zoomIn')
            }
            if (box.className.includes('title2_span')) {
              $('.drop3').css('transform', 'translate(0, 0)');
              $('.drop3 .drop').addClass('zoomIn')
            }
            if (box.className.includes('title_span')) {
              var dec = $(box).closest('.title').next('.dec');
              var pic = dec.next('.pic');
              pic.css('transform', 'translate(0, 0)');
              dec.css('transform', 'translate(0, 0)');
              pic.addClass('fadeInDown');
              dec.addClass('fadeInUp');
              setTimeout(() => {
                $('.pao1').css('transform', 'translate(0, 0)');
                $('.pao1').addClass('slideInRightSelf');
              }, 800);
            }
          }
        }
      );
      wow.init();
    },
  },
  mounted() {
    this.setWow();
    // var hrefId = this.$route.query.id - 1
    // if (this.$route.query.id) {
    //   $('html').animate({ scrollTop: 0 }, 0)
    //   if (this.$route.query.id == 3) {
    //     var h = $('.pic2').offset().top * document.documentElement.clientWidth / 1920
    //   } else {
    //     var h = $('.title').eq(hrefId).offset().top * document.documentElement.clientWidth / 1920
    //   }
    //   $('html').animate({ scrollTop: h }, 1000)
    // }
  }
}
</script>

<style lang="scss" scoped>
.catering {
  .catering_content {
    width: 1320px;
    margin: 110px auto 100px;
    position: relative;
    .title {
      font-size: 36px;
      color: #000;
      font-weight: bold;
      margin-top: 70px;
      &::before {
        content: '';
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background: #f39f43;
        vertical-align: middle;
        display: inline-block;
        margin-right: 38px;
      }
      > div {
        overflow: hidden;
        display: inline-block;
        vertical-align: middle;
      }
      span {
        display: inline-block;
      }
    }
    .title2 {
      margin-top: 110px;
    }
    .dec {
      font-size: 26px;
      color: #1e1e1e;
      line-height: 50px;
      text-indent: 2em;
      margin-top: 20px;
      margin-bottom: 60px;
    }
    .pic {
      border-radius: 20px;
      overflow: hidden;
      position: relative;
      z-index: 1;
      img{
        width: 100%;
      }
    }
    .pic1 {
      border: 1px solid #fff;
      background-color: rgb(182, 188, 203);
      box-shadow: 0px 3px 24px 0px rgba(69, 86, 131, 0.4);
      width: 1118px;
      height: 640px;
      background: url('@/assets/hotel1.jpg') no-repeat center;
      background-size: cover;
      margin: 0 auto;
    }
    .pic2 {
      border-radius: 20px;
      background-color: rgb(182, 188, 203);
      box-shadow: 0px 3px 24px 0px rgba(69, 86, 131, 0.4);
      width: 1118px;
      height: 640px;
      margin: 0 auto;
    }
    .tip {
      color: rgb(236, 92, 6);
      font-size: 26px;
      text-align: center;
      margin-top: 60px;
      margin-bottom: 100px;
    }
  }
  .pao1 {
    border-radius: 50%;
    background-image: -moz-linear-gradient( 130deg, rgb(255,163,122) 0%, rgb(254,233,168) 78%, rgb(254,233,168) 79%);
    background-image: -webkit-linear-gradient( 130deg, rgb(255,163,122) 0%, rgb(254,233,168) 78%, rgb(254,233,168) 79%);
    background-image: -ms-linear-gradient( 130deg, rgb(255,163,122) 0%, rgb(254,233,168) 78%, rgb(254,233,168) 79%);
    background-image: linear-gradient( 130deg, rgb(255,163,122) 0%, rgb(254,233,168) 78%, rgb(254,233,168) 79%);
    opacity: 0.5;
    left: 300px;
    top: 930px;
    width: 239px;
    height: 239px;
  }
  .pao2 {
    width: 100%;
    left: 0;
    top: 2648px;
  }
  .pao3 {
    left: 0;
    top: 2600px;
  }
  .pao5 {
    border-radius: 50%;
    position: absolute;
    left: 1458px;
    top: 2058px;
    background-image: -moz-linear-gradient( -20deg, rgb(184,242,211) 13%, rgb(254,253,168) 100%);
    background-image: -webkit-linear-gradient( -20deg, rgb(184,242,211) 13%, rgb(254,253,168) 100%);
    background-image: -ms-linear-gradient( -20deg, rgb(184,242,211) 13%, rgb(254,253,168) 100%);
    background-image: linear-gradient( -20deg, rgb(184,242,211) 13%, rgb(254,253,168) 100%);
    width: 240px;
    height: 240px;
  }
  .hotel_main{
    width: 930px;
    margin-top: 40px;
    .more1{
      float: right;
      margin-bottom: 56px;
    }
    .hotel_img{
      border: 1px solid #fff;
      border-radius: 20px;
      background-color: rgb(182, 188, 203);
      box-shadow: 0px 3px 24px 0px rgba(69, 86, 131, 0.4);
      width: 1117px;
      height: 640px;
      overflow: hidden;
      margin-left: 106px;
      position: relative;
      z-index: 1;
      img{
        width: 100%;
      }
    }
  }
  .hotel_dec{
    text-indent: 2em;
    line-height: 46px;
  }
  .more1 {
    transition: all 0.4s;
    width: 183px;
    height: 52px;
    text-align: center;
    line-height: 52px;
    border-radius: 999px;
    background: rgb(234, 94, 62);
    background: -moz-linear-gradient(
      30deg,
      rgb(234, 94, 62) 0%,
      rgb(253, 148, 36) 100%
    );
    background: -webkit-linear-gradient(
      30deg,
      rgb(234, 94, 62) 0%,
      rgb(253, 148, 36) 100%
    );
    background: -o-linear-gradient(
      30deg,
      rgb(234, 94, 62) 0%,
      rgb(253, 148, 36) 100%
    );
    background: -ms-linear-gradient(
      30deg,
      rgb(234, 94, 62) 0%,
      rgb(253, 148, 36) 100%
    );
    background: linear-gradient(
      120deg,
      rgb(234, 94, 62) 0%,
      rgb(253, 148, 36) 100%
    );
    color: #fff;
    font-size: 24px;
    letter-spacing: 3px;
    text-indent: 3px;
    cursor: pointer;
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 36px;
    -webkit-box-shadow: 0px 3px 10px 0px rgba(230, 132, 26, 0.38);
    -moz-box-shadow: 0px 3px 10px 0px rgba(230, 132, 26, 0.38);
    box-shadow: 0px 3px 10px 0px rgba(230, 132, 26, 0.38);
    span {
      display: inline-block;
      width: 36px;
      height: 36px;
      border-radius: 50%;
      color: #fd9424;
      font-size: 0;
      font-weight: bold;
      transition: all 0.4s;
      margin-left: 0;
      transform: translate(14px, 0) scale(0);
      transform-origin: left center;
      background: #fff url('~@/assets/arrow10.png') no-repeat;
      background-size: 18px auto;
      background-position: center center;
    }
    &:hover {
      padding-left: 0;
      span {
        opacity: 1;
        transform: translate(14px, 0) scale(1);
      }
    }
  }
}
</style>